import React from 'react';
import ViewLabel from '../generic-component/ViewLabel';
import ImageSlider from '../generic-slider/ImageSlider';
import ViewTextGeneric from '../generic-component/ViewTextGeneric';
import ViewTextGenericCatalog from '../generic-component/ViewTextGenericCatalog';
import ViewTextReactMarkdown from '../generic-component/ViewTextReactMarkdown';
import ViewTextGenericMultilevel from '../generic-component/ViewTextGenericMultilevel';
import ViewTextGenericIndicators from '../generic-component/ViewTextGenericIndicators';
import ViewCatalogLocationGeneric from '../generic-component/ViewCatalogLocationGeneric';
import ViewCatalogLocationGenericRelation from '../generic-component/ViewCatalogLocationGenericRelation';
import ViewYearGeneric from '../generic-component/ViewYearGeneric';
import ViewDateGeneric from '../generic-component/ViewDateGeneric';

const DynamicViewEngine = ({
  list,
  values,
  t,
  ProblemTableComponent: ProblemTable,
  relationKeys = {
    multimedia: "ModuleFile_To_Alternative",
    problems: "ModuleProblem_To_Alternative"
  },
  isPreviewMode = false,
  /** nested ficha completa: unión show_view_full | show_view_preview */
  forceCompleteFields = false,
}) => {
  if (!list || list.length === 0) return null;

  return list.map((techSecondary) => {
    const shouldShow = forceCompleteFields
      ? (techSecondary.show_view_full === true || techSecondary.show_view_preview === true)
      : (isPreviewMode ? techSecondary.show_view_preview : techSecondary.show_view_full);
    if (!shouldShow) return null;

    const varField = techSecondary.field;
    const varRelation = techSecondary.key_relation;

    const commonProps = {
      field: varField,
      moduleText: techSecondary.module_text,
    };

    switch (techSecondary.component_view) {
      case "ViewGroupLabel":
        return (
          <ViewLabel 
            key={techSecondary.id} 
            {...commonProps} 
            occupation={techSecondary.occupation_view} 
          />
        );

      case "ViewTextGenericMultimedias":
        const mediaKey = relationKeys.multimedia;
        return (
          <div className="row justify-content-center mb-4" key={techSecondary.id}>
            <div className="col-md-10 text-center">
              {values?.[mediaKey] && values[mediaKey].length > 0 && (
                <div className="gallery-section">
                  <h5 className="mb-3" style={{ fontWeight: "bold" }}>
                    {t("technology.slider.title")}
                  </h5>
                  <div style={{ width: '100%', height: '450px', position: 'relative' }}>
                    <ImageSlider slides={values[mediaKey]} />
                  </div>
                </div>
              )}
            </div>
          </div>
        );

      case "ViewTextGeneric":
        return (
          <ViewTextGeneric 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            values2={varRelation} 
            occupation={techSecondary.occupation_view} 
            //css_class={techSecondary.css_class} 
          />
        );

      case "ViewTextGenericCatalog":
        return (
          <ViewTextGenericCatalog 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            values2={varRelation} 
            occupation={techSecondary.occupation_view} 
            css_class={techSecondary.css_class}
          />
        );

      case "ViewMarkdownTextGeneric":
        return (
          <ViewTextReactMarkdown 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            occupation={techSecondary.occupation_view} 
          />
        );

      case "ViewTextGenericMultilevel":
        return (
          <ViewTextGenericMultilevel 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            values2={varRelation}
            occupation={techSecondary.occupation_view} 
            css_class={techSecondary.css_class} 
          />
        );

      case "ViewTextGenericIndicators":
        return (
          <ViewTextGenericIndicators 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            occupation={techSecondary.occupation_view} 
          />
        );

      case "ViewTextGenericProblems":
        const problemKey = relationKeys.problems;
        return (
          <div key={techSecondary.id}>
            {ProblemTable && values?.[problemKey] && values[problemKey].length > 0 && (
              <div className="row">
                <div className="col-md-12">
                  <ProblemTable 
                    problemList={values[problemKey]} 
                    field={varField} 
                    moduleText={techSecondary.module_text} 
                  />
                </div>
              </div>
            )}
          </div>
        );

      case "ViewCatalogLocationGenericRelation":
        const customOccupation = varField === 'catalogcountries_id' ? 8 : techSecondary.occupation_view;
        return (
          <ViewCatalogLocationGenericRelation 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            values2={varRelation} 
            occupation={customOccupation} 
          />
        );

      case "ViewCatalogLocationGeneric":
        return (
          <ViewCatalogLocationGeneric 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            occupation={techSecondary.occupation_view} 
          />
        );

      case "ViewYearGeneric":
        return (
          <ViewYearGeneric 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            occupation={techSecondary.occupation_new} 
          />
        );

      case "ViewDateGeneric":
        return (
          <ViewDateGeneric 
            key={techSecondary.id} 
            {...commonProps} 
            values={values} 
            occupation={techSecondary.occupation_new} 
          />
        );

      default:
        return null;
    }
  });
};

export default DynamicViewEngine;
